import { WindTurbineAlarmInfoBar } from "./WindTurbineAlarmInfoBar";
export default WindTurbineAlarmInfoBar;
